<form [formGroup]="this.formGroup" (ngSubmit)="this.handleSubmit()">
@switch (formState()) {
			<!--state, when password was changed-->
	@case ("successful-changed"){
    <app-authenticate-ui-headline>
      <app-authenticate-ui-headline-title>{{"Passwort erfolgreich geändert" | translate : "header-headline-password-changed"}}</app-authenticate-ui-headline-title>
      <app-authenticate-ui-headline-description>
        {{"Sie können sich ab jetzt mit Ihrem neuem Passwort anmelden." | translate : "header-description-password-changed"}}
      </app-authenticate-ui-headline-description>
    </app-authenticate-ui-headline>

			@if(isAuthorized()){
					<button  mat-flat-button (click)="onBackToReferrerClick()" class="submit-button button--tertiary">{{"Zurück zur Projektübersicht" | translate : "action-return-to-project-overview" : "feature/auth"}}</button>
			}
			@else {
				<button  mat-flat-button (click)="onBackToReferrerClick()" class="submit-button button--tertiary">{{"Zurück zum Login" | translate : "action-return-to-login" : "feature/auth"}}</button>
			}
	}
	<!--state, when registration-link is expired-->
	@case ("registration-expired"){
    @if(!hasRequestedOnce()){
      <app-authenticate-ui-headline>
        <app-authenticate-ui-headline-title>{{"Link abgelaufen!" | translate : "header-headline-expired"}}</app-authenticate-ui-headline-title>
        <app-authenticate-ui-headline-description>
          {{"Lassen Sie sich den Link erneut zuschicken um zur Passwortvergabe zu\ngelangen. Der Link wird an Ihre E-Mail-Adresse gesendet." | translate : "header-description-expired"}}
        </app-authenticate-ui-headline-description>
      </app-authenticate-ui-headline>
      <button mat-flat-button class="submit-button button--tertiary" type="button" (click)="handleResendLink()">
        {{"Link erneut anfordern" | translate : "action-resend-link"}}
      </button>
    } @else {
      <app-authenticate-ui-headline>
        <app-authenticate-ui-headline-title>{{"Link versendet!" | translate : "header-headline-send"}}</app-authenticate-ui-headline-title>
        <app-authenticate-ui-headline-description>
          {{"Sie erhalten in Kürze eine E-Mail mit einem neuen Registrierungslink.\nEs kann einen Moment dauern, bis die E-Mail ankommt. Prüfen Sie bitte auch\nIhren Spam-Ordner und den Speicher Ihres Postfachs." | translate : "header-description-send"}}
        </app-authenticate-ui-headline-description>
      </app-authenticate-ui-headline>

      @if (showResendCta()){
        <app-authenticate-ui-headline-description>
          {{ "Keinen Link erhalten?" | translate: "label-no-link-received" }}
          <a href=""
             class="reset-link"
             role="button"
             tabindex="0"
             (click)="onResendLink($event)"
             (keydown.space)="onResendLink($event)">
            {{ "Erneut senden" | translate: "action-resend-link" }}
          </a>
        </app-authenticate-ui-headline-description>

      } @else {
        <app-authenticate-ui-headline-description> {{ "Neuer Link in 120 Sek.verfügbar." | translate: "label-link-cooldown" }}</app-authenticate-ui-headline-description>
        <app-shared-notify-chip level="success">
          <ogs-m3-icon prefix="fal" icon="paper-plane"/>
          <app-shared-notify-chip-value>
            {{"Link wurde versendet!" | translate : "status-link-send"}}
          </app-shared-notify-chip-value>
        </app-shared-notify-chip>
      }
    }
	}

  @case('invalid-registration-link'){
    <app-authenticate-ui-headline>
      <app-authenticate-ui-headline-title>{{"Link ungültig" | translate : "header-headline-invalid"}}</app-authenticate-ui-headline-title>
      <app-authenticate-ui-headline-description>
        {{"Der von Ihnen aufgerufene Registrierungslink ist ungültig. Bitte überprüfen Sie Ihr Postfach auf eine aktuelle E-Mail." | translate : "header-description-invalid-link"}}
      </app-authenticate-ui-headline-description>
    </app-authenticate-ui-headline>
  }
			<!--normal-state-->
	@default{
			@if(hasServerError()){
					<app-shared-notify-chip status="error">
							<ogs-m3-icon prefix="fal" icon="exclamation-triangle"/>
									<app-shared-notify-chip-value>
										@if(serverErrorMessage().localizedMessage){
													{{serverErrorMessage().localizedMessage!.defaultText | translate: serverErrorMessage().localizedMessage!.token}}
										}
										@else if(serverErrorMessage().message){
											{{serverErrorMessage().message}}
										}
									</app-shared-notify-chip-value>
					</app-shared-notify-chip>
			}

          <app-authenticate-ui-headline>
            <app-authenticate-ui-headline-title>{{"Neues Passwort vergeben" | translate : "header-headline"}}</app-authenticate-ui-headline-title>
            <app-authenticate-ui-headline-description>
              {{"Das neue Passwort muss mindestens 8 Zeichen lang sein.\nEs muss mindestens 1 Grossbuchstaben sowie 1 Kleinbuchstaben beinhalten." | translate : "header-description"}}
            </app-authenticate-ui-headline-description>
          </app-authenticate-ui-headline>
          <app-shared-caps-lock-notice />

					<mat-form-field>
							<mat-label>{{"Neues Passwort" | translate : "input-new-password"}}</mat-label>
							<input matInput [type]="this.hideNewPassword() ? 'password' : 'text'" formControlName="newPassword" />
							@if (this.newPassword.hasError("format")) {
									<mat-error>{{"Passwort entspricht nicht den Anforderungen" | translate : "input-error-password-wrong-format"}}</mat-error>
							}
            <div class="action__container" matSuffix>
							<button
									mat-icon-button
									matSuffix
									tabindex="-1"
									type="button"
									(click)="this.handleToggleOfPassword('new-password')"
							>
									<ogs-m3-icon prefix="fal" [icon]="this.hideNewPassword() ? 'eye' : 'eye-slash'" />
							</button>
            </div>
					</mat-form-field>
					<mat-form-field>
							<mat-label>{{"Neues Passwort wiederholen" | translate : "input-new-password-repeat"}}</mat-label>
							<input matInput [type]="this.hideNewPasswordRepeat() ? 'password' : 'text'" formControlName="newPasswordRepeat" />
							@if (this.newPasswordRepeat.hasError("match")) {
									<mat-error>{{"Passwort stimmt nicht überein" | translate : "input-error-password-mismatch"}}</mat-error>
							}
            <div class="action__container" matSuffix>
							<button
									mat-icon-button
									matSuffix
									tabindex="-1"
									type="button"
									(click)="this.handleToggleOfPassword('new-password-repeat')"
							>
									<ogs-m3-icon prefix="fal" [icon]="this.hideNewPasswordRepeat() ? 'eye' : 'eye-slash'" />
							</button>
              </div>
					</mat-form-field>
					<button mat-flat-button class="submit-button button--tertiary" [disabled]="!this.formGroup.valid || this.hasServerError() || isLoading()" type="submit">
							{{"Speichern" | translate : "action-save"}}
					</button>
	}
}

</form>
